import Glide, { Breakpoints, Controls, Swipe } from '@glidejs/glide/entry/entry-modular.js'

const options = {
  rewind: false,
  bound: true,
  perView: 3,
  gap: 74,
  dragThreshold: false,

  breakpoints: {
    550: {
      perView: 1,
      gap: 20
    },

    880: {
      perView: 2,
      gap: 30
    },

    1100: {
      perView: 3,
      gap: 40
    }
  },

  classes: {
    arrow: {
      disabled: 'is-disabled'
    }
  }
}

const sliders = document.querySelectorAll('.js-news-slider')

sliders.forEach(slider => {
  new Glide(slider, options).mount({ Breakpoints, Controls, Swipe })
})
